import { useNavigate, useLocation } from "react-router-dom";

/** Smart-scrolls to #download. If currently on Home, just scrolls.
 *  Otherwise navigates Home and scrolls after route paint. */
export function useScrollToDownload() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const scroll = () => {
      const el = document.getElementById("download");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    if (pathname === "/") {
      scroll();
    } else {
      navigate("/");
      // wait for Home to render
      setTimeout(scroll, 120);
    }
  };
}
